// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#sidebar {
  padding-top: 60px;
  height: calc(100vh - 60px);
  background: var(--primaryTheme);
  overflow-y: auto;
  overflow-x: hidden;
  transition: 0.1s;
  z-index: 999;
}
#sidebar #menu {
  padding-top: 1rem;
}

#sidebar.closeNav {
  width: 75px;
}
#sidebar.closeNav h3 {
  display: none;
  transition: 0.2s;
}

.menuLogo {
  padding: 15px 15px 7px;
}

.hrMenu {
  margin: 0.4rem 10px;
  border-color: #848484;
  border-style: solid;
  border-bottom: none;
}

.menuItemAcc {
  cursor: pointer;
  padding: 9px 1.2rem 8px;
  width: 100%;
  border: none;
  text-align: left;
  outline: none;
  transition: 0.4s;
  display: flex;
  align-items: center;
  gap: 1rem;
  box-sizing: border-box;
  transition: 0.3s;
  white-space: nowrap;
}

#menu .menuItemAcc h3 {
  margin: 0;
  text-decoration: none;
  transition: 0.25s;
}
#menu .menuItemAcc h3:hover {
  color: #35afaf;
}

#menu h3 {
  color: var(--primaryFontTheme);
}

.menuIcon {
  width: 25px;
  height: 25px;
}
.menuIcon svg {
  width: 100%;
  height: 100%;
}
.menuIcon svg path {
  stroke: #35afaf;
}

.active .menuIcon {
  color: #f9543a;
}

.burgerContainer {
  display: flex;
  align-items: center;
  min-height: 62px;
  padding: 0px 0.9em 0px;
  background-color: #35afaf;
}
.burgerContainer h3 {
  cursor: pointer;
}
.burgerContainer h3:hover {
  color: #1f1f1f !important;
  transition: 0.5s;
}

.menuWrap {
  display: flex;
  flex-direction: column;
  position: absolute;
  bottom: 20px;
}
.menuWrap.small {
  align-items: center;
}

.cookBurger {
  width: 25px;
  height: 20px;
  margin: 12px 10px 8px 10px;
  position: relative;
  cursor: pointer;
  display: inline-block;
}
.cookBurger span {
  background-color: #1f1f1f;
  position: absolute;
  border-radius: 2px;
  transition: 0.3s cubic-bezier(0.8, 0.5, 0.2, 1.4);
}

.clickBurger {
  margin-left: 15px;
  transform: rotate(90deg);
}

.cookBurger span:nth-child(1) {
  width: 60%;
  height: 1.8px;
  display: block;
  top: 3.2px;
  left: 8px;
  rotate: 45deg;
}

.clickBurger span:nth-child(1) {
  left: 0px;
  top: 14px;
  width: 25px;
  transition: 0.3s cubic-bezier(0.8, 0.5, 0.2, 1.4);
  transform: rotate(45deg);
  transition-delay: 150ms;
}

.cookBurger span:nth-child(2) {
  width: 90%;
  height: 2px;
  display: block;
  top: 9px;
  left: 0px;
}

.clickBurger span:nth-child(2) {
  left: -2px;
  top: 20px;
  width: 17px;
  transition: 0.3s cubic-bezier(0.8, 0.5, 0.2, 1.4);
  transform: rotate(45deg);
  transition-delay: 50ms;
}

.cookBurger span:nth-child(3) {
  width: 60%;
  height: 1.8px;
  display: block;
  bottom: 3px;
  left: 8px;
  rotate: -45deg;
}

.clickBurger span:nth-child(3) {
  left: 11px;
  top: 19px;
  width: 17px;
  transition: 0.3s cubic-bezier(0.8, 0.5, 0.2, 1.4);
  transform: rotate(0deg);
  transition-delay: 100ms;
}

@media only screen and (max-width: 899px) {
  #mobileHead {
    visibility: visible;
    height: auto;
  }
  #sidebar {
    width: 100vw;
    transition: 0.2s;
  }
  .burgerContainer:focus #sidebar {
    width: 150px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SideBar/SideBar.scss","webpack://./src/tokens.scss"],"names":[],"mappings":"AAEA;EACE,iBAAA;EAEA,0BAAA;EACA,+BAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AAFF;AAIE;EACE,iBAAA;AAFJ;;AAKA;EACE,WAAA;AAFF;AAGE;EACE,aAAA;EACA,gBAAA;AADJ;;AAIA;EACE,sBAAA;AADF;;AAGA;EACE,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,mBAAA;AAAF;;AAEA;EACE,eAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AACA;EACE,SAAA;EACA,qBAAA;EACA,iBAAA;AAEF;AAAE;EACE,cCrDW;ADuDf;;AACA;EACE,8BAAA;AAEF;;AAAA;EACE,WAAA;EACA,YAAA;AAGF;AADE;EACE,WAAA;EACA,YAAA;AAGJ;AADI;EACE,eCpES;ADuEf;;AACA;EACE,cCtEe;ADwEjB;;AAqBA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBCrGa;ADmFf;AAmBE;EACE,eAAA;AAjBJ;AAmBE;EACE,yBAAA;EACA,gBAAA;AAjBJ;;AAqBA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;AAlBF;AAoBE;EACE,mBAAA;AAlBJ;;AAsBA;EACE,WAAA;EACA,YAAA;EACA,0BAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;AAnBF;AAqBE;EACE,yBCxHU;EDyHV,kBAAA;EACA,kBAAA;EACA,iDAAA;AAnBJ;;AAsBA;EACE,iBAAA;EACA,wBAAA;AAnBF;;AAqBA;EACE,UAAA;EACA,aAAA;EACA,cAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;AAlBF;;AAoBA;EACE,SAAA;EACA,SAAA;EACA,WAAA;EACA,iDAAA;EACA,wBAAA;EACA,uBAAA;AAjBF;;AAmBA;EACE,UAAA;EACA,WAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;AAhBF;;AAkBA;EACE,UAAA;EACA,SAAA;EACA,WAAA;EACA,iDAAA;EACA,wBAAA;EACA,sBAAA;AAfF;;AAiBA;EACE,UAAA;EACA,aAAA;EACA,cAAA;EACA,WAAA;EACA,SAAA;EACA,cAAA;AAdF;;AAgBA;EACE,UAAA;EACA,SAAA;EACA,WAAA;EACA,iDAAA;EACA,uBAAA;EACA,uBAAA;AAbF;;AAgBA;EACE;IACE,mBAAA;IACA,YAAA;EAbF;EAgBA;IAEI,YAAA;IACA,gBAAA;EAfJ;EAoBE;IAAS,uBAAA;EAjBX;AACF","sourcesContent":["@import \"../../tokens.scss\";\n\n#sidebar {\n  padding-top: 60px;\n  // width: 250px;\n  height: calc(100vh - 60px);\n  background: var(--primaryTheme);\n  overflow-y: auto;\n  overflow-x: hidden;\n  transition: 0.1s;\n  z-index: 999;\n\n  #menu {\n    padding-top: 1rem;\n  }\n}\n#sidebar.closeNav {\n  width: 75px;\n  h3 {\n    display: none;\n    transition: 0.2s;\n  }\n}\n.menuLogo {\n  padding: 15px 15px 7px;\n}\n.hrMenu {\n  margin: 0.4rem 10px;\n  border-color: #848484;\n  border-style: solid;\n  border-bottom: none;\n}\n.menuItemAcc {\n  cursor: pointer;\n  padding: 9px 1.2rem 8px;\n  width: 100%;\n  border: none;\n  text-align: left;\n  outline: none;\n  transition: 0.4s;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  box-sizing: border-box;\n  transition: 0.3s;\n  white-space: nowrap;\n}\n#menu .menuItemAcc h3 {\n  margin: 0;\n  text-decoration: none;\n  transition: 0.25s;\n\n  &:hover {\n    color: $primaryColor;\n  }\n}\n#menu h3 {\n  color: var(--primaryFontTheme);\n}\n.menuIcon {\n  width: 25px;\n  height: 25px;\n\n  svg {\n    width: 100%;\n    height: 100%;\n\n    path {\n      stroke: $primaryColor;\n    }\n  }\n}\n.active .menuIcon{\n  color: $secondaryColor;\n}\n\n// #switchContainer {\n//   padding-left: calc(1.2rem - 7px);\n//   label {\n//     color: var(--primaryFontTheme);\n//     font-size: 1.17rem;\n//     font-weight: bold;\n//   }\n//   label:hover {\n//     cursor: pointer;\n//   }\n// }\n\n// .switchSmall {\n//   /*make it centered*/\n//   padding-left: unset !important;\n//   label {\n//     display: none;\n//   }\n// }\n\n.burgerContainer {\n  display: flex;\n  align-items: center;\n  min-height: 62px;\n  padding:0px 0.9em 0px;\n  background-color: $primaryColor;\n  h3{\n    cursor: pointer;\n  }\n  h3:hover{\n    color: $primaryDark !important;\n    transition: 0.5s;\n  }\n}\n\n.menuWrap {\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  bottom: 20px;\n\n  &.small {\n    align-items: center;\n  }\n}\n\n.cookBurger {\n  width: 25px;\n  height: 20px;\n  margin: 12px 10px 8px 10px;\n  position: relative;\n  cursor: pointer;\n  display: inline-block;\n\n  span {\n    background-color: $primaryDark;\n    position: absolute;\n    border-radius: 2px;\n    transition: 0.3s cubic-bezier(0.8, 0.5, 0.2, 1.4);\n  }\n}\n.clickBurger {\n  margin-left: 15px;\n  transform: rotate(90deg);\n}\n.cookBurger span:nth-child(1) {\n  width: 60%;\n  height: 1.8px;\n  display: block;\n  top: 3.2px;\n  left: 8px;\n  rotate: 45deg;\n}\n.clickBurger span:nth-child(1) {\n  left: 0px;\n  top: 14px;\n  width: 25px;\n  transition: 0.3s cubic-bezier(0.8, 0.5, 0.2, 1.4);\n  transform: rotate(45deg);\n  transition-delay: 150ms;\n}\n.cookBurger span:nth-child(2) {\n  width: 90%;\n  height: 2px;\n  display: block;\n  top: 9px;\n  left: 0px;\n}\n.clickBurger span:nth-child(2) {\n  left: -2px;\n  top: 20px;\n  width: 17px;\n  transition: 0.3s cubic-bezier(0.8, 0.5, 0.2, 1.4);\n  transform: rotate(45deg);\n  transition-delay: 50ms;\n}\n.cookBurger span:nth-child(3) {\n  width: 60%;\n  height: 1.8px;\n  display: block;\n  bottom: 3px;\n  left: 8px;\n  rotate: -45deg;\n}\n.clickBurger span:nth-child(3) {\n  left: 11px;\n  top: 19px;\n  width: 17px;\n  transition: 0.3s cubic-bezier(0.8, 0.5, 0.2, 1.4);\n  transform: rotate(0deg);\n  transition-delay: 100ms;\n}\n\n@media only screen and (max-width: 899px) {\n  #mobileHead {\n    visibility: visible;\n    height: auto;\n  }\n\n  #sidebar {\n      // display: none;\n      width: 100vw;\n      transition: 0.2s;\n    }\n  \n\n  .burgerContainer:focus{\n    #sidebar{width: 150px !important;}\n  }\n}\n","$primaryColor: #35afaf;\n$primaryColorHover: scale-color($primaryColor, $lightness: -10%);\n$primaryColorDisabled: scale-color($primaryColor, $lightness: -50%);\n$secondaryColor: #f9543a;\n$secondaryColorHover: scale-color($secondaryColor, $lightness: -10%);\n$secondaryColorDisabled: scale-color($secondaryColor, $lightness: -50%);\n\n \n $primaryLight: #f9f9f9;\n $secondaryLight: #c9c9c9;\n \n $primaryDark:#1f1f1f;\n $secondaryDark:#2d2d2d;\n\n "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
